import { InventoryTypeFieldValueMessage } from "./InventoryTypeFieldValueMessage"

export class UpdateInventoryItemMessage {
  isCoreProduct: boolean
  price: number
  sku: string
  totalQuantityOnHand: number
  inventoryTypeFieldValues: InventoryTypeFieldValueMessage[]

  constructor(
    isCoreProduct: boolean,
    price: number,
    sku: string,
    totalQuantityOnHand: number,
    inventoryTypeFieldValues: InventoryTypeFieldValueMessage[]) {
      this.isCoreProduct = isCoreProduct
      this.price = price
      this.sku = sku
      this.totalQuantityOnHand = totalQuantityOnHand
      this.inventoryTypeFieldValues = inventoryTypeFieldValues
  }
}
